React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('board_member_add_multiple')
Util = require 'app/scripts/lib/util'

options = {
  'normal': {
    label: t.l('add-as-members'),
    description: t.l('board-members-can-edit-comment-and-invite-people-to-this-board'),
  },
  'observer': {
    label: t.l('add-as-observers'),
    description: t.l('observers-can-view-and-comment-on-this-board'),
  },
}

module.exports = class BoardObserverOptionComponent extends React.Component
  constructor: ->
    @state = isOpen: false

  render: t.renderable ->
    { onChange, value } = @props
    { isOpen } = @state

    selectedOption = options[value]

    t.div '.board-observer-dropdown', {
        onBlur:  => @setState({ isOpen: false }),
        tabIndex: 0
      }, =>
      t.div '.board-observer-selected', { onClick: => @setState({ isOpen: !isOpen }) },  =>
        t.p =>
          t.text selectedOption.label
        t.icon 'down'
      if isOpen
        t.div '.board-observer-options' , =>
          Object.keys(options).map (key) =>
            t.div '.board-observer-option', { onClick: (e) =>
                onChange(key)
                @setState({ isOpen: false })
              }, =>
                t.div '.board-observer-option-title', =>
                  t.text options[key].label
                  if key == value
                    t.icon 'check'
                t.div '.board-observer-option-description', =>
                  t.text options[key].description


